import i18next from 'i18next'
import React, { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { APIRequest } from '../../../api'
import { BasicButton, Document } from '../../../components'
import { acceptedTerms, logoutEverywhere } from '../../../store/profile'
import { useThunkDispatch } from '../../../hooks/useThunkDispatch'
import { TermsCard } from '../../Authenticated/modals/AcceptTermsModal/TermsCard'
import css from './TermsAcceptancePage.module.scss'

function safeInternalPath(path: string | null | undefined): string | null {
	if (!path) return null
	if (!path.startsWith('/')) return null
	if (path.startsWith('//')) return null
	return path
}

export const TermsAcceptancePage = (): React.ReactElement => {
	const title = useMemo(() => i18next.t('components.modals.AcceptTermsModal.title', { defaultValue: 'Accept Terms and Conditions' }), [])
	const dispatch = useDispatch()
	const dispatchThunk = useThunkDispatch()
	const navigate = useNavigate()
	const location = useLocation()

	const searchParams = new URLSearchParams(location.search)
	const resume = safeInternalPath(searchParams.get('resume'))

	const handleAgreeClicked = async (): Promise<void> => {
		const accepted = await APIRequest.User.acceptLatestTerms()
		if (accepted) {
			dispatch(acceptedTerms())
			navigate(resume || '/', { replace: true })
		}
	}

	const handleLogoutClicked = async (): Promise<void> => {
		await dispatchThunk(logoutEverywhere())
		navigate('/', { replace: true })
	}

	return (
		<Document title={title}>
			<div className={css.container}>
				<div className={css.card}>
					<TermsCard />
					<div className={css.buttons}>
						<BasicButton variant="danger" onClick={handleLogoutClicked}>
							{i18next.t('components.modals.AcceptTermsModal.logout')}
						</BasicButton>
						<BasicButton variant="blue" onClick={handleAgreeClicked} test-id="btn-agree">
							{i18next.t('components.modals.AcceptTermsModal.agree')}
						</BasicButton>
					</div>
				</div>
			</div>
		</Document>
	)
}
